module.exports = __webpack_public_path__ + "img/login-icon.023d858a.svg";